import DOMPurify from 'dompurify'

const replaceStr = function (text, pattern, replacement) {
  let patternArr = _.isArray(pattern) ? pattern : [pattern]
  let replacementArr = _.isArray(replacement) ? replacement : [replacement]
  _.forEach(patternArr, function (val, key) {
    text = text.replace(new RegExp(val, 'g'), replacementArr[key])
  })
  return text
}

const sanitizeHtml = function (html) {
  if (!html) return ''
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'a', 'ul', 'ol', 'li', 'span', 'div'],
    ALLOWED_ATTR: ['href', 'target', 'class'],
    FORBID_TAGS: ['script', 'object', 'embed', 'form', 'input', 'iframe'],
    FORBID_ATTR: ['onload', 'onclick', 'onerror', 'onmouseover', 'style']
  })
}

const linkify = function (inputText) {
  let replacedText, replacePattern1, replacePattern2, replacePattern3

  if (!inputText) {
    inputText = ''
  }

  // First sanitize the input to remove any malicious HTML
  inputText = sanitizeHtml(inputText)

  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim
  replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>')

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>')

  //Change email addresses to mailto:: links.
  replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim
  replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>')

  return replacedText
}

const isPdf = (imageUrl) => {
  return imageUrl?.includes('.pdf')
}

const empty = (variable) => {
  try {
    if (!variable || variable === 'null' || variable === '0') return true

    if (typeof variable === 'object' && !Object.keys(variable).length) return true

    if (Array.isArray(variable) && !variable.length) return true

    return false
  } catch (e) {
    return true
  }
}

export { replaceStr, linkify, isPdf, empty, sanitizeHtml }
